export function removeEmpty<T = any>(data): T {
	return Object.entries(data).reduce((obj, [key, value]) => {
		if (isObject(value)) {
			const cleanedValue = removeEmpty(value);

			if (Object.keys(cleanedValue).length > 0) {
				obj[key] = cleanedValue;
			}
		} else if (
			Array.isArray(value)
				? value.length > 0
				: !!value || isBoolean(value) || isNumeric(value as string)
		) {
			obj[key] = value;
		}
		return obj;
	}, {} as T);
}

function isObject(obj) {
	return typeof obj === 'object' && obj !== null && !Array.isArray(obj);
}

function isBoolean(value) {
	return typeof value === 'boolean';
}

function isNumeric(val: string): boolean {
	if (val === '' || val === null) {
		return false;
	}
	return !isNaN(Number(val));
}

export function isFunction(obj: any): obj is Function {
	return obj && typeof obj === 'function' && obj.constructor === Function;
}

export function resolveFieldData(data: any, field: any): any {
	if (data && field) {
		if (isFunction(field)) {
			return field(data);
		} else if (field.indexOf('.') == -1) {
			return data[field];
		} else {
			let fields: string[] = field.split('.');
			let value = data;
			for (let i = 0, len = fields.length; i < len; ++i) {
				if (value == null) {
					return null;
				}
				value = value[fields[i]];
			}
			return value;
		}
	} else {
		return null;
	}
}
